module.exports = __webpack_public_path__ + "img/uiw_pay.1f924a03.svg";